import React from 'react';

const UnauthorizedPage = () => (
    <div className="flex flex-col items-center justify-center h-full text-center">
        <h1 className="text-2xl font-bold text-pro-dark-text-primary">Accès non autorisé</h1>
        <p className="mt-2 text-pro-dark-text-secondary">Votre compte est en attente d'activation.</p>
    </div>
);

export default UnauthorizedPage;

